import React, { useEffect, useState } from "react";
import { QualificationView } from "../Views/qualificationView";
import { RecoilRoot } from 'recoil';
import { StoreSearchPage } from "./storeSearchPage";
import { PresentPage } from "./presentPage";
import { ProductsPage } from "./productsPage";
import { EntryFormPage } from "./entryFromPage";
import { OtherProductsView } from "../Views/otherProductsView";

export const TopPage = () => {

    const [flow, setFlow] = useState('qualification')
    const [defaultValue, setDefaultValue] = useState(
        {
            questionType: 0,
            questionCheck: 0,
            store: null,
            apply:[  {product:false, present:false, appKey:0}],
            formValue:false,
        }
    )
   
    const setQuestionAndNextFlow = (type, check) => {
        setDefaultValue({
            ...defaultValue,
            questionType: type,
            questionCheck: check,
        })
        //(暫定対応)応募資格はtypeによってフローが変わる為、ここでネクスト処理を行う.
        type === 3 ? setFlow('selectStore') : setFlow('selectProducts')
    }

    const setStore = (store) => {
        setDefaultValue({
            ...defaultValue,
            store: store,
        })
    }

    const [applyKey, setApplyKey] = useState(0)
    const [apply, setApply] = useState({product:false, present:false, appKey:0})
    
    const setProducts = (product) => {
        let updateApply = defaultValue.apply
        const setKey = Object.keys(updateApply).filter(key => updateApply[key].appKey === applyKey )[0]
        if(setKey){
            updateApply[setKey] = { 
                product:product, present:false, appKey:applyKey
             }
        }else{
            updateApply = [
                ...updateApply,
                { product:product, present:false, appKey:applyKey}   
            ]
        }
        setDefaultValue({
            ...defaultValue,
            apply: updateApply,
        })
    }

    const setPresent = (present) => {
        
        let updateApply = defaultValue.apply
        const setKey = Object.keys(updateApply).filter(key => updateApply[key].appKey === applyKey )[0]
        //購入商品が設定されている === setKeyが存在しているはず。
        if(setKey){
            updateApply[setKey] = { 
                product:updateApply[setKey].product,
                present:present, 
                appKey:applyKey
             }
        }else{}

        setDefaultValue({
            ...defaultValue,
            apply: updateApply,
        })
    }


    const selectApply = async( key ) => {
        const select =  defaultValue.apply.filter(app => app.appKey === key)[0]

        await setApply(
            select ? select : {product:false, present:false, appKey:0}
        )
        
    }

    const setFormValue = (inputValue) => {
        setDefaultValue({
            ...defaultValue,
            formValue: inputValue,
        })
    }

    /*
        ::Flow
        questionType : 1 / 2
        qualification -> selectProducts -> selectPresent 
                -> otherProducts -> yes: selectProducts -> selectPresent -> otherProducts(ループ)
                -> No:  selectStore -> sendForm
        questionType : 3
        qualification -> selectStore -> sendForm
    */
    const next = () => {
        switch (flow){
            case 'qualification':
                defaultValue.questionType === 3 ? setFlow('selectStore') : setFlow('selectProducts')
                break;
            
            case 'selectProducts':
                setFlow('selectPresent')
                break;
            
            case 'addProducts':
                setFlow('selectPresent')
                break;

            case 'selectPresent':
                setFlow('otherProducts')
                break;

            case 'selectStore':
               setFlow('sendForm')
                break;
        }
    }
    
    const prev = () => {
        switch (flow){

            case 'selectProducts':
                setFlow('qualification')
                break;
            
            case 'addProducts':
                selectApply(applyKey-1).then(() => {
                    setApplyKey(applyKey-1)
                    setFlow('otherProducts')
                })
                break

            case 'selectPresent':
                applyKey > 1 ?  setFlow('addProducts') : setFlow('selectProducts')
                break;

            case 'selectStore':
                defaultValue.questionType === 3 ? 
                    setFlow('qualification') : 
                    selectApply(applyKey).then(() => {  
                        setFlow('selectPresent') })
                break;

            case 'sendForm': 
                setFlow('selectStore') 
                break;
        
        }
    }


    const ohterProductYes = () => {
        selectApply(applyKey+1).then(() => {
            setApplyKey(applyKey+1)
            setFlow('addProducts')
        })
        
    } 
    const ohterProductNo = () => {
        setFlow('selectStore')
        
    } 

    
    return (
        <>
        {
            flow === 'qualification' &&
            <QualificationView {
                ...{next, 
                    setQuestionAndNextFlow, 
                    defaultValue}}></QualificationView>
            
        }
        {
            flow === 'selectStore' &&
            <StoreSearchPage {...{next, prev, setStore, defaultValue}}></StoreSearchPage>
        }
        {
            flow === 'selectProducts' &&
            <ProductsPage {...{
                next, 
                prev,
                type: defaultValue.questionType, 
                setProducts, 
                defaultValue:apply}}></ProductsPage>
        }
        {
            flow === 'selectPresent' &&
            <PresentPage  {...{
                next, 
                prev, 
                defaultValue:apply, 
                setPresent}}></PresentPage>
        }
        {
            flow === 'otherProducts' &&
            <OtherProductsView
                {...{
                    ohterProductYes,
                    ohterProductNo
                }}
            ></OtherProductsView>
        }
        {
                flow === 'addProducts' &&
                <ProductsPage {...{
                    next, 
                    prev,
                    type: 2, 
                    setProducts, 
                    defaultValue:apply}}></ProductsPage>
        }
        {
            flow === 'sendForm' &&
            <EntryFormPage  {...{next, prev, setFormValue, defaultValue}}></EntryFormPage>
        }
        </>
    )
}